import { defineComponent as _defineComponent } from 'vue'
import Http from '../../../core/http/http.service';
import MostOrderedProductsViewModel = Vertica.LouisPoulsen.Application.SalesDocuments.ViewModels.MostOrderedProductsViewModel;
import MostOrderedProductViewObject = Vertica.LouisPoulsen.Application.SalesDocuments.ViewModels.MostOrderedProductViewObject;
import MostOrderedProductsTable from '@/ui/views/mostorderedproducts/MostOrderedProductsTable.vue';
import MostOrderedProductsWebRequest = Vertica.LouisPoulsen.Application.SalesDocuments.Requests.MostOrderedProductsWebRequest;
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MostOrderedProducts',
  props: {
    pageTitle: null,
    allowPurchase: { type: Boolean },
    maxLines: null
  },
  emits: ["loaded"],
  setup(__props: any, { emit }: { emit: ({(e: 'loaded', value: boolean): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    pageTitle?: string,
    allowPurchase: boolean,
    maxLines: number
 }




onMounted(search);

const searchActive = ref<boolean>(false);
const searchResults = ref<MostOrderedProductViewObject[]>([]);
const asyncActive = ref<boolean>(false);
const finishedSapLookup = ref<{ [key: string]: boolean }>({});

function asyncMode(response: MostOrderedProductsViewModel) : boolean {
    if (response.lines.length === 0) { return false; }

    if (response.lines[0].purchasePrice) { return false; }

    return true;
}

function search(): void {
    searchActive.value = true;
    asyncActive.value = false;

    const request: MostOrderedProductsWebRequest = {
        maxLines: props.maxLines
    };

    Http.cancelableRequest('POST', 'mostorderedproducts/search', 'mostOrderedProducts', request).then((response: MostOrderedProductsViewModel) => {
        if (response.lines === null) { response.lines = []; }

        searchResults.value = response.lines;
        const asyncModeValue = asyncMode(response);
        asyncActive.value = asyncModeValue;

        finishedSapLookup.value = response.lines.reduce(
            (prev: { [key: string]: boolean }, line: MostOrderedProductViewObject) => {
                prev[line.variantId] = !asyncModeValue;
                return prev;
            }, {});

        emit('loaded', searchResults.value.length > 0);

        if (asyncModeValue) {
            updateSalesInfo();
        }
    }).finally(() => {
        if (!asyncActive.value) {
            searchActive.value = false;
        }
    });
}

async function updateSalesInfo() {
    const chunkSize = 5;
    const requests : SalesInfoWebRequest[] = [];
    for (let i = 0; i < Math.ceil(searchResults.value.length / chunkSize); i++) {
        requests.push({
            sapIds: searchResults.value.slice(i * chunkSize, (i + 1) * chunkSize).map(x => x.variantId)
        });
    }

    for (let j = 0; j < requests.length; j++) {
        const request = requests[j];
        const sapLookupResult = Object.assign({}, finishedSapLookup.value);
        await Http.post('salesinfo/BatchedSalesInfo', request).then((response: SalesInfoViewModel) => {
            request.sapIds.forEach(id => {
                const salesInfo = response.variants.find(x => x.variantId === id);
                if (salesInfo) {
                    const row = searchResults.value.find(x => x.variantId === id);
                    if (row) {
                        sapLookupResult[row.variantId] = true;

                        row.delivery = salesInfo.delivery;
                        row.stock = salesInfo.stock;
                        row.priceRetail = salesInfo.priceRetail;
                        row.discount = salesInfo.discount;
                        row.additionalDiscount = salesInfo.additionalDiscount;
                        row.purchasePrice = salesInfo.purchasePrice;
                        row.hasPrice = salesInfo.hasPrice;
                        row.isNeoVariant = salesInfo.isNeoVariant;

                        if (!row.description) {
                            row.description = salesInfo.description;
                        }
                    }
                } else {
                    // Remove entire result if there is no SAP result
                    searchResults.value = searchResults.value.filter(result => result.variantId !== id);
                }
            });
        });
        finishedSapLookup.value = sapLookupResult;
    }
    searchActive.value = false;
}

return { __sfc: true,props, emit, searchActive, searchResults, asyncActive, finishedSapLookup, asyncMode, search, updateSalesInfo, MostOrderedProductsTable }
}

})